import { addReference } from '../language/reference';
import { terms } from '../language/terms';

export const appName = 'agwasuite';
export const appDisplayName = 'Agwa Apps';
const appUrl = 'https:apps.agwa.com.au';
const agwaAbbreviation = terms.agwa.value;
const agwaFullName = 'Australian Glass and Window Association';

addReference('app', appName, 'The name of the application')
  .add('displayName', appDisplayName)
  .add('url', appUrl, 'The URL of the application')
  .add('description', `A suite of tools for the ${terms.agwa.value} community`)
  .add('abbreviation', agwaAbbreviation, 'The abbreviation of the AGWA')
  .add('fullName', agwaFullName, 'The full name of the AGWA');

addReference('company', agwaAbbreviation, 'The name of the company')
  .add('displayName', agwaFullName)
  .add('url', 'http:www.agwa.com.au', 'The URL of the company');

addReference(
  'glossary',
  'glossary',
  'The glossary of terms used in the application'
)
  .add(
    'terms',
    'Terms and Conditions',
    'The terms and conditions of the application'
  )
  .add('privacy', 'Privacy Policy', 'The privacy policy of the application')
  .add(
    'termsUrl',
    'https://www.agwa.com.au/terms-and-conditions',
    'The URL of the terms and conditions'
  )
  .add(
    'privacyUrl',
    'https://www.agwa.com.au/privacy-policy',
    'The URL of the privacy policy'
  )
  .add('contactUs', 'Contact Us', 'The contact us page of the application')
  .add(
    'contactUsUrl',
    'https://www.agwa.com.au/contact-us',
    'The URL of the contact us page'
  );

// The vocabulary that used to live here - member, member-plural, company, company-plural, user,
// user-plural, membership, user-staff - now lives in `ui/src/language/terms.ts` as a typed object.
//
// Note what the old list shows: `member` and `company` were two keys for the SAME entity, one the
// current word and one the word it is becoming. Keying on the internal domain collapses them into
// a single `loginGroup` term whose VALUE changes, which is the clearest argument for the rule.
//
// What remains under `glossary` is static labels and URLs. They are not vocabulary, they have no
// grammatical variants, and the mandatory-variant rule does not apply to them. The name is now
// misleading and renaming this bucket is tracked as a follow-up.
